import React from "react";

import { isImageUrl } from "utils/cms/icon";

import CmsPreviewShell from "./CmsPreviewShell";
import mockData from "./mockData.json";

import type { CategoryMock, CmsComponentProps } from "./types";

const CategoryComponent: React.FC<CmsComponentProps> = ({ layout, items: userItems }) => {
  const items =
    userItems && userItems.length > 0
      ? userItems
          .filter((i) => i.is_active !== false)
          .map((i, idx) => ({
            id: idx,
            title: i.title,
            icon: i.icon ?? "",
            link: i.link ?? "",
          }))
      : (mockData.category as CategoryMock[]);

  return (
    <CmsPreviewShell>
      <div className={`cms-category cms-category--${layout}`}>
        {items.map((item) => {
          const iconIsImage = isImageUrl(item.icon);
          const iconClass = iconIsImage ? "cms-category__icon cms-category__icon--image" : "cms-category__icon";
          return (
            <div key={item.id} className="cms-category__item">
              <span className={iconClass}>{iconIsImage ? <img src={item.icon} alt={item.title} /> : item.icon || "❓"}</span>
              <span className="cms-category__name">{item.title}</span>
            </div>
          );
        })}
      </div>
    </CmsPreviewShell>
  );
};

export default CategoryComponent;
